import { createContext, useContext } from 'react';
import { jsx } from 'react/jsx-runtime';
const RouterContext = /*#__PURE__*/createContext({
  pathname: '/'
});
function useRouter() {
  return useContext(RouterContext);
}
function SharedComponentsProvider({
  children,
  pathname
}) {
  return /*#__PURE__*/jsx(RouterContext.Provider, {
    value: {
      pathname
    },
    children: children
  });
}
export { SharedComponentsProvider, useRouter };
//# sourceMappingURL=RouterContext.js.map
